import ShapeBase from './ShapeBase';
import predefinedProcessSVG from '../assets/icons/predefined-process.svg';
import { svgToIcon } from '../utils/svg';
import type Shape from '../objects/Shape';

class ShapePredefinedProcess extends ShapeBase {
  constructor(fabricObject: Shape) {
    super(fabricObject);

    // Set min scale to avoid drawing inner lines outside of shape
    fabricObject.minScaleLimit = (this.offset() / 100) * 2.5;
  }

  static renderIcon() {
    return svgToIcon(predefinedProcessSVG);
  }

  offset() {
    return 30;
  }

  calcTextMargin() {
    return {
      top: 5,
      left: this.offset() + 5,
      right: this.offset() + 5,
      bottom: 5,
    };
  }

  render(ctx: CanvasRenderingContext2D) {
    const obj = this.fabricObject;
    const { width: w, height: h } = obj;
    const left = -w / 2 + this.horizontalOffset();
    const right = w / 2 - this.horizontalOffset();

    ctx.beginPath();
    this._setBorderDash(ctx);
    ctx.moveTo(-w / 2, -h / 2);
    ctx.lineTo(w / 2, -h / 2);
    ctx.lineTo(w / 2, h / 2);
    ctx.lineTo(-w / 2, h / 2);
    ctx.lineTo(-w / 2, -h / 2);

    ctx.moveTo(left, -h / 2);
    ctx.lineTo(left, h / 2);

    ctx.moveTo(right, h / 2);
    ctx.lineTo(right, -h / 2);
    ctx.closePath();

    obj._renderPaintInOrder(ctx);
  }
}

export default ShapePredefinedProcess;
